export enum MediaType {
  IMAGE = 'IMAGE',
  SEATMAP = 'SEATMAP',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  STREAMING = 'STREAMING',
}
